export default "__VITE_PUBLIC_ASSET__ecaa9e98__"